define(function (require) {

    var $ = require('jquery'),
        _ = require('underscore');

    var Dialog = {},
        Menu = {};

    var modalBg = _.once(function () {
        return $('<div id="modalBG" class="modalBackground" style="display:none;" ></div>').appendTo(document.body);
    });

    function toggleDialogProgress(dialog, body) {
        var elem = $(dialog);
        if (!(elem.length)) return;
        body = $(body);
        if (!(body.length)) {
            body = elem.find('.body:first');
            if (!(body.length)) return;
        }
        Dialog.Current.Body = body;

        var size = { width: elem.outerWidth(false), height: elem.outerHeight(false) };
        var pos = elem.offset();
        $('#dialogProgress').css({ width: size.width + 'px', height: size.height + 'px', left: pos.left + 'px', top: pos.top + 'px' }).show();
        $('#modalThrobber').css('marginTop', (size.height < 100 ? '10px' : '50px'));
    }

    function toggle(elem, options) {
        elem = $(elem);
        if (!elem.length) return;
        options = options || {};

        // move element to either be a child of the body or the primary ASP.NET form for positioning context.
        $(document.body).append(elem, $('#dialogProgress'));

        if (elem.is(':hidden')) {
            $(window).resize(resizeBackground)
                  .scroll(resizeBackground);
            resizeBackground().show();

            resizeDialog(elem, options);

            if (Dialog.Current) {
                Dialog.Current.trigger('hudl:close');
                Dialog.Current.hide();
            }
            Dialog.Current = elem;
            elem.trigger('hudl:open');

            // hide <select> elements so they don't shine thru the modal in IE6
            $(document.body).addClass('hideSelects');
        } else {
            $(window).unbind('resize', resizeBackground)
                  .unbind('scroll', resizeBackground);
            elem.hide();
            modalBg().hide();
            elem.trigger('hudl:close');
            $('#dialogProgress').hide();
            Dialog.Current = null;

            // re-show <select> elements (only affects IE6 w/ css)
            $(document.body).removeClass('hideSelects');
        }
    }

    function togglePopup() {
        if (Menu.Current) {
            Menu.Current.hide().fire('hudl:close');
        }
    }

    function resizeDialog(elem, options) {
        elem = $(elem);
        if (!elem.length) return;
        options = options || {};

        var $doc = $(document.body);
        var leftScroll = $doc.scrollLeft(),
            topScroll = $doc.scrollTop();

        var leftPos = (($(window).width() - elem.outerWidth(false)) / 2) + leftScroll;
        leftPos = leftPos < 0 ? 0 : leftPos;
        leftPos = options.left || leftPos;
        var topPos = (($(window).height() - elem.outerHeight(false)) / 2) + topScroll;
        topPos = topPos < 0 ? 0 : topPos;
        topPos = options.top || topPos;

        elem.css({ 'zIndex': 10001, position: 'absolute', left: leftPos + 'px', top: topPos + 'px', display: '' });
    }

    function resizeBackground() {
        function getMaxHeight() {
            return Math.max($(window).height(), $(document.body).height());
        }
        function getMaxWidth() {
            return Math.max($(window).width(), $(document.body).width());
        }

        var bg = modalBg();
        //Theres a few cases where the body is smaller than the viewport => Math.max
        var bgHeight = getMaxHeight();
        var bgWidth = getMaxWidth();
        bg.width(bgWidth).height(bgHeight);

        if (Dialog.Current && Dialog.Current.Body) {
            var pos = Dialog.Current.Body.offset();
            $('#dialogProgress').css({ left: pos.left + 'px', top: pos.top + 'px' });
        }

        return bg;
    }

    return {
        toggleDialogProgress: toggleDialogProgress,
        togglePopup: togglePopup,
        resizeDialog: resizeDialog,
        resizeBackground: resizeBackground,
        toggle: toggle,
        toggleCurrent: function () {
            Dialog.Current && toggle(Dialog.Current);
        }
    };
});
